import(/* webpackMode: "eager" */ "/codebuild/output/src1881698648/src/github.com/bitstone/offerz-nextjs/src/app/global-error.tsx");
